import { render, staticRenderFns } from "./depoimentos.vue?vue&type=template&id=f46e441e&scoped=true&"
import script from "./depoimentos.vue?vue&type=script&lang=js&"
export * from "./depoimentos.vue?vue&type=script&lang=js&"
import style0 from "./depoimentos.vue?vue&type=style&index=0&id=f46e441e&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f46e441e",
  null
  
)

export default component.exports